// extracted by css-extract-rspack-plugin
export default {"highlighter":"Code_highlighter__cc7Sg","wrapper":"Code_wrapper__gP3Kl","copy":"Code_copy__jYSXc"};